import React from "react";
import Box from "@mui/material/Box";
import { BsCircleFill } from "react-icons/bs";
import { eventStatus } from "../../dataProvider/interfaces/IEvent";
import { getEventStatusColor } from "../../utils";
export interface Props {
  status: eventStatus;
}

const EventStatus = ({ status }: Props) => {
  return (
    <Box>
      <BsCircleFill
        size="10"
        color={getEventStatusColor(status)}
        style={{ marginRight: "5px" }}
      />
      {status}
    </Box>
  );
};

export default EventStatus;
